import * as _ from "lodash";
import * as angular from "angular";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";
import { ScreenUtils } from "../../helper/screen.helper";
import { EventDataProvider } from "../../data-provider/event.dp";
import { Group } from "../../models/group.model";
import { eventHasEnded } from "../../models/event.model";

let ViewEventComponent = {
    selector: "vcViewEvent",
    templateUrl: "/angular/components/event/view-event.component.html",
    bindings: {
        event: "=",
        rsvp: "=?",
        image: "=?",
        smallPreview: "=?",
        viewOnly: "=?",
    },
    controller: class ViewEventController {
        // * bindings for typescript compiler *
        public event: any;
        public rsvp?: any;
        public image?: any;
        public smallPreview?: any;
        public viewOnly?: any;
        // ************************************

        public readonly days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];
        public readonly months = [
            { num: 0, name: "January" },
            { num: 1, name: "February" },
            { num: 2, name: "March" },
            { num: 3, name: "April" },
            { num: 4, name: "May" },
            { num: 5, name: "June" },
            { num: 6, name: "July" },
            { num: 7, name: "August" },
            { num: 8, name: "September" },
            { num: 9, name: "October" },
            { num: 10, name: "November" },
            { num: 11, name: "December" },
        ];

        public today = new Date();
        public timezone: any;
        public activeUser: User;
        public attendingStatus = false;
        public responded = false;
        public attendingTitle: string;
        public activeGroups: Group[] = [];
        public doneGroups: Group[] = [];

        public $scope: any;
        public screen: ScreenUtils;
        private userDataProvider: UserDataProvider;
        private dataProvider: EventDataProvider;

        constructor(
            $scope: any,
            $cookies: any,
            __time_zone: any,
            ScreenUtils: ScreenUtils,
            UserDataProvider: UserDataProvider,
            EventDataProvider: EventDataProvider
        ) {
            this.$scope = $scope;
            this.screen = ScreenUtils;

            this.userDataProvider = UserDataProvider;
            this.dataProvider = EventDataProvider;

            this.today = new Date();
            this.timezone = this.today
                .toLocaleTimeString("en-us", {
                    timeZoneName: "short",
                    timeZone: __time_zone,
                })
                .split(" ")[2];

            this.userDataProvider
                .getUser($cookies.get("uid"))
                .then((user: User) => {
                    this.activeUser = user;
                });
        }

        $onInit(): void {
            this.attendingTitle = eventHasEnded(this.event)
                ? "Attended"
                : "Attending";

            this.processEventGroups();
            this.$scope.$watch(
                () => `${this.event.groups}`,
                (newValue: string, oldValue: string) => {
                    if (newValue !== oldValue) {
                        this.processEventGroups();
                    }
                }
            );
        }

        processEventGroups(): void {
            this.activeGroups = [];
            this.doneGroups = [];

            this.event.groups.forEach((group: Group) => {
                if (
                    group.gstatus === "Active" ||
                    group.gstatus === "Inactive"
                ) {
                    this.activeGroups.push(group);
                }
                if (group.gstatus === "Done") this.doneGroups.push(group);
            });
        }

        sendRsvp(status: string): void {
            this.dataProvider
                .sendRsvp(this.event, status)
                .then((data: object) => {
                    this.rsvp = data;
                    angular.forEach(this.event.attendance, (list: any) => {
                        for (let i = list.users.length - 1; i >= 0; i--) {
                            if (list.users[i].uid == this.activeUser.uid) {
                                list.users.splice(i, 1);
                                list.count = list.users.length;
                            }
                        }
                    });
                    this.event.attendance[status.toLowerCase()].users.push(
                        this.activeUser
                    );
                    this.event.attendance[status.toLowerCase()].count =
                        this.event.attendance[
                            status.toLowerCase()
                        ].users.length;
                });
        }

        groupsString(groups: Group[]): string {
            return _.map(groups, (g: Group) => g.gname).join(", ");
        }
    },
};

angular
    .module("event")
    .component(ViewEventComponent.selector, ViewEventComponent);
